import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';
import { ErrorMessage } from '../../model/error-message';

@Component({
  selector: 'app-mareon-error-message-content',
  templateUrl: './error-message-content.component.html',
  styleUrls: ['./error-message-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateModule,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    NgOptimizedImage,
    MatIcon,
    MatDialogTitle,
  ],
})
export class ErrorMessageContentComponent {
  data = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<ErrorMessageContentComponent>>(MatDialogRef);
  errorMessage: ErrorMessage;

  constructor() {
    this.errorMessage = this.data;
  }

  onAbbrechen() {
    this.dialogRef.close();
  }

  onCopyToClipboard() {
    const element = document.querySelector('#fehlerMeldung');
    if (element) {
      const text = (element as HTMLElement).innerText;
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      navigator.clipboard.writeText(textArea.value).then(() => {});
      document.body.removeChild(textArea);
    }
  }
}
